import { type LineChartCategory } from 'components/LineChart/types';
import { createChartCategories } from 'components/LineChart/utils';
import { AREA_COLORS, BAROMETER_AREA_ORDER } from 'constants/surveys';
import type { BarometerSpecificAreaKey } from 'types/surveys';

export const SPECIFIC_AREAS = BAROMETER_AREA_ORDER as readonly BarometerSpecificAreaKey[];

export const createBarometerCategories = (getLabel: (key: string) => string): LineChartCategory[] =>
  createChartCategories(SPECIFIC_AREAS, getLabel, area => AREA_COLORS[area]);

export const formatBarometerXAxisLabel = (value: string): string => value.split(' (')[0];

export const getBarometerCategoryLabel = (t: (key: string) => string, category: string): string =>
  t(`BarometerResults.Areas.${category}`) || category;

export const calculateBarometerYDomain = (): {
  yDomain: [number, number];
  yTicks: number[];
} => ({
  yDomain: [0, 100],
  yTicks: [0, 20, 40, 60, 80, 100],
});

const formatPercentage = (value: number): string => {
  const rounded = Math.round(value * 100) / 100;
  return rounded % 1 === 0 ? `${rounded}%` : `${rounded.toFixed(2)}%`;
};

export const formatBarometerYAxisLabel = (value: number): string => formatPercentage(value);

export const formatBarometerTooltipValue = (value: string | number | undefined): string => {
  if (value === undefined || value === null) return '';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(numValue) ? String(value) : formatPercentage(numValue);
};
